module.exports = __webpack_public_path__ + "static/TWT_Sc0050_Shot2_thumb-cb8cdde0ee146b817c78644516103357.jpg";